import accordionPaneView from './accordionPaneComponent.html';
import './accordionPaneComponent.css';

export function accordionPaneComponent() {
	return {
		bindings: {
			label: '@',
			icon: '@?',
			isOpen: '=?',
			onClick: '&?',
		},
		require: {
			accordion: '^^shAccordion',
		},
		controllerAs: 'vm',
		transclude: true,
		controller: accordionPaneComponentCtrl,
		template: accordionPaneView,
	};
}

export class accordionPaneComponentCtrl {
	constructor($timeout) {
		'ngInject';
		this.$timeout = $timeout;
	}

	$onInit() {
		this.accordion.registerPane(this);
	}

	$onDestroy() {
		this.accordion.unregisterPane(this);
	}

	clickLabel() {
		if (this.onClick) {
			// allow prevented pane from opening
			let isPrevented = false;
			const $event = {
				isDefaultPrevented: () => isPrevented,
				preventDefault: () => (isPrevented = true),
			};
			this.onClick({ $event });
			this.$timeout(() => {
				if (!isPrevented) {
					this.accordion.paneClick(this);
				}
			}, 0);
		} else {
			this.accordion.paneClick(this);
		}
	}
}
